import{m as n}from"./chunk-HBP5N4FR.js";n();var r=10,x=(o,c=10)=>{let t=Math.log(.005),m=(Math.log(5)-t)/(c-0);return Math.exp(t+m*(o-0))};export{r as a,x as b};
//# sourceMappingURL=chunk-E3ZZOQNR.js.map
